{
  "title": "Gradebook",
  "description": "Every graded item of a class in one grid — tests, homework and your own columns.",
  "class": "Class",
  "selectClass": "Choose a class",
  "noClasses": {
    "title": "No classes to show",
    "teacherText": "You do not teach any class yet — the gradebook fills in per class.",
    "adminText": "This school has no classes yet. The gradebook fills in once one exists.",
    "action": "Go to classes"
  },
  "from": "From",
  "to": "To",
  "clearRange": "Clear dates",
  "pupil": "Pupil",
  "total": "Total",
  "loadFailed": "The gradebook could not be loaded.",
  "empty": {
    "items": "This class has no graded items yet. Assign a test, publish homework, or add a column.",
    "pupils": "No pupils are enrolled in this class yet.",
    "filteredItems": "No graded items fall inside these dates. Clear them to see every graded item."
  },
  "kinds": {
    "test": "Test",
    "homework": "Homework",
    "project": "Project",
    "manual": "Column"
  },
  "cell": {
    "graded": "Graded",
    "pending": "Awaiting a grade",
    "missing": "Nothing handed in",
    "notApplicable": "Not on this team",
    "notApplicableShort": "—",
    "missingShort": "×",
    "pendingShort": "·",
    "label": "{{pupil}} — {{item}}",
    "saving": "Saving",
    "saveFailed": "The grade could not be saved."
  },
  "totals": {
    "label": "{{earned}} of {{possible}}",
    "percent": "{{percent}}%"
  },
  "scale": {
    "points": "Points",
    "ua_12": "12-point scale"
  },
  "maxScore": "max {{max}}",
  "export": {
    "csv": "Export CSV",
    "xlsx": "Export XLSX",
    "started": "Your export is downloading.",
    "failed": "The export could not be downloaded."
  },
  "column": {
    "add": "Add column",
    "addTitle": "New grade column",
    "addDescription": "A column of your own — oral answers, class work, a project. Scores are stored as points.",
    "editTitle": "Edit column",
    "menu": "Column actions",
    "edit": "Edit",
    "archive": "Archive",
    "fields": {
      "title": "Title",
      "titlePlaceholder": "Oral answer",
      "maxScore": "Max score",
      "date": "Date",
      "kind": "Kind of work"
    },
    "validation": {
      "titleRequired": "Give the column a title.",
      "maxScoreRequired": "Enter a maximum score.",
      "maxScorePositive": "The maximum score must be greater than 0.",
      "dateRequired": "Choose a date."
    },
    "created": "Column added.",
    "updated": "Column updated.",
    "archiveTitle": "Archive “{{title}}”?",
    "archiveDescription": "The column leaves the gradebook; the grades already given stay on record.",
    "archived": "Column archived.",
    "save": "Save"
  },
  "openSource": "Open the page where this column is graded"
}
